import styles from '../IMSLDAPValidator.module.scss';
import Base from 'pages/Base/Base';
import TransformedDataTable from './TransformedDataTable';
import { nanoid } from 'nanoid';

const PeoplesoftOnPremResults = peoplesoftResults => {
	// Prefix for Peoplesoft On-Prem attributes
	const PREFIX = 'CA_PS_CL';

	const headers = [
		{
			Value: 'Network ID(sAMAccountName)',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Manager Flag (managerFlag)',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Groups (memberOf)',
			props: { sort: null, onSortChange: null },
		},
		{ Value: 'Attributes', props: { sort: null, onSortChange: null } },
	];

	const extractGroups = groups => {
		if (!Array.isArray(groups)) return [];
		return groups
			.filter(g => typeof g === 'string' && !g.startsWith(PREFIX))
			.sort((a, b) =>
				a.localeCompare(b, undefined, { sensitivity: 'base' }),
			);
	};

	const extractHRAttributes = groups => {
		if (!Array.isArray(groups)) return [];
		return groups
			.filter(g => typeof g === 'string' && g.startsWith(PREFIX))
			.sort((a, b) =>
				a.localeCompare(b, undefined, { sensitivity: 'base' }),
			);
	};

	const rows = Object.entries(peoplesoftResults).map(([key, data]) => {
		return {
			Cells: {
				'Network ID(sAMAccountName)': {
					Value: data.ErrorMessage ? data.ErrorMessage : data.CN,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Manager Flag (managerFlag)': {
					Value: data.ManagerFlag,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Groups (memberOf)': {
					Value: data.Groups
						? extractGroups(data.Groups).join('\n')
						: null,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Attributes: {
					Value: data.Groups
						? extractHRAttributes(data.Groups).join('\n')
						: null,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: nanoid(),
		};
	});

	return (
		<Base title='Peoplesoft OU Corporate' className={styles.psContainer}>
			<TransformedDataTable
				rows={rows}
				headers={headers}
				className={styles.Table_Overrides2}
			/>
		</Base>
	);
};

export default PeoplesoftOnPremResults;
